import React from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';
import { intlMessage } from 'constants/propTypes';
import Message from 'components/Message';

import './SmartRateTopicPanelLayout.scss';

const { block, element } = bem('smart-rate-topic-panel-layout');

const SmartRateTopicPanelLayout = ({ children, summaryBody, summaryHeading }) => (
  <div className={block()}>
    <div className={element('summary')}>
      <Message as="h2" className={element('summary-heading')} message={summaryHeading} />
      <div className={element('summary-body')}>{summaryBody}</div>
    </div>
    <div className={element('content')}>{children}</div>
  </div>
);

SmartRateTopicPanelLayout.propTypes = {
  children: PropTypes.node,
  summaryBody: PropTypes.node.isRequired,
  summaryHeading: intlMessage.isRequired,
};

export default SmartRateTopicPanelLayout;
